export const NAME = 'publicationsHome';
export const ID = 'publications-home';
